import { render, staticRenderFns } from "./FullTextSearchOptions.vue?vue&type=template&id=427a3dcb&scoped=true&"
import script from "./FullTextSearchOptions.vue?vue&type=script&lang=js&"
export * from "./FullTextSearchOptions.vue?vue&type=script&lang=js&"
import style0 from "./FullTextSearchOptions.vue?vue&type=style&index=0&id=427a3dcb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427a3dcb",
  null
  
)

export default component.exports